import { render, staticRenderFns } from "./FieldInfo.vue?vue&type=template&id=a483c6ae&scoped=true&"
import script from "./FieldInfo.vue?vue&type=script&lang=ts&"
export * from "./FieldInfo.vue?vue&type=script&lang=ts&"
import style0 from "./FieldInfo.vue?vue&type=style&index=0&id=a483c6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a483c6ae",
  null
  
)

export default component.exports